import React, { Component } from 'react'
import propTypes from 'prop-types'
import moment from 'moment'


import CloseSVG from 'component/svgComponents/close'
import FilterSVG from 'component/svgComponents/filter'
import DownloadSVG from 'component/svgComponents/download'

import Form from 'component/commonReport/Form'
import Card from 'component/utils/Card'
import Modal from 'component/utils/Modal'
import CompactTable from 'component/utils/CompactTable'
import Accordion from 'component/utils/Accordion'
import { NavTab, Tab } from 'component/NavTab'
import * as spinnerActions from 'action/spinner'
import * as code8Actions from 'action/code8occurrences'
import * as reportActions from 'action/report'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import './accordion.css'

let signalController;
const EVENT_MANAGEMENT_CODE_REPORT = 23
const OCCURENCE_SECTIONS_CODE_REPORT = 28
const OCCURENCE_STORES_CODE_REPORT = 29
const CODE8REVENUE_SECTIONS_CODE_REPORT = 30
const CODE8REVENUE_STORE_CODE_REPORT = 31
const OCCURENCE_CODE_8 = 8
const AccordionTableTitleLost = ({ branch, value, percentage }) => (
  <table className='table-compact text-uppercase'>
    <tbody>
      <tr />
      <tr>
        <td width='50%'>{branch}</td>
        <td width='25%' className='align-center'>
          {value}
        </td>
        <td width='25%' className='align-center'>
          {percentage}
        </td>
      </tr>
    </tbody>
  </table>
)

AccordionTableTitleLost.propTypes = {
  branch: propTypes.string,
  value: propTypes.string,
  percentage: propTypes.string,
}

const AccordionTableTitleStores = ({
  branch,
  ocurrQtt,
  ocurrPercentage,
  treatedQtt,
  tretaedPercentage,
  totalValue
}) => (
  <table className='table-compact text-uppercase'>
    <tbody>
      <tr />
      <tr>
        <td width='30%'>{branch}</td>
        <td width='20%' className='align-center'>
          {ocurrQtt}
        </td>
        <td width='7.5%' className='align-center'>
          {ocurrPercentage}
        </td>
        <td width='15%' className='align-center'>
          {treatedQtt}
        </td>
        <td width='7.5%' className='align-center'>
          {tretaedPercentage}
        </td>
        <td  width='20%' className='align-center'>
          {totalValue}
        </td>
      </tr>
    </tbody>
  </table>
)

AccordionTableTitleStores.propTypes = {
  ocurrQtt: propTypes.string,
  ocurrPercentage: propTypes.string,
  treatedQtt: propTypes.string,
  tretaedPercentage: propTypes.string,
  branch: propTypes.string,
  value: propTypes.string,
  percentage: propTypes.string,
  totalValue: propTypes.string
}

const ReportDownloadBtn = ({ disabled, fullW, t, onReport }) => {
  let classNames = 'btn btn-download'
  if (fullW) classNames += ' full-w'

  const styles = {
    width: '18px',
    height: '18px',
    margin: '0px',
    marginRight: '16px',
    fill: '#fff'
  }
  return (
    <button disabled={disabled} onClick={onReport} className={classNames}>
      <DownloadSVG fill={styles.fill} style={styles} />
      <span>{t('commonReport.download')}</span>
    </button>
  )
}

ReportDownloadBtn.propTypes = {
  disabled: propTypes.bool,
  fullW: propTypes.bool,
  t: propTypes.func,
  onReport: propTypes.func
}
class NewOccurrenceCode8 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showReport: false,
      showFilters: false,
      detailsMode: null,
      dateStartFiltered: null,
      dateEndFiltered: null,
      formData: {},
    }
  }




  compactTableAccordionDataMock(data) {
    return {
      hideHeader: true,
      columns: [
        {
          selector: 'sections',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'value',
          centerData: true,
          parsingFn: (v) => `R$ ${v}`,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: data ?? []
    }
  }

  compactTableAccordionStoresDataMock(details) {
    return {
      hideHeader: true,
      columns: [
        {
          selector: 'sections',
          extraDataProps: {
            width: '30%',
          },
        },
        {
          selector: 'ocurrencesQtt',
          centerData: true,
          extraDataProps: {
            width: '20%',
          },
        },
        {
          selector: 'ocurrencesPercent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '7.5%',
          },
        },
        {
          selector: 'treatedQtt',
          centerData: true,
          extraDataProps: {
            width: '15%',
          },
        },
        {
          selector: 'treatedPercent',
          parsingFn: (v) => `${v}%`,
          centerData: true,
          extraDataProps: {
            width: '7.5%',
          },
        },
        {
          selector: 'totalValue',
          centerData: true,
          centerTitle: true,
          extraDataProps: {
            width: '20%',
          },
        },

      ],
      data:  details ?? []
    }
  }

  get compactTableModalDataMock() {
    const { translate, code8Occurrences } = this.props

    return {
      columns: [
        {
          title: translate('ruptures.sectionTitle'),
          selector: 'sections',
        },
        {
          title: translate('order_status.value'),
          selector: 'value',
          centerTitle: true,
          centerData: true,
          parsingFn: (v) => `R$ ${v}`,
        },
        {
          title: translate('percentage'),
          selector: 'percent',
          centerTitle: true,
          centerData: true,
          parsingFn: (v) => `${v}%`,
        },
      ],
      data: code8Occurrences.revenueLossSections ?? []
    }
  }

  get compactTableModalDataMockSections() {
    const { translate, code8Occurrences } = this.props

    return {
      columns: [
        {
          title: translate('ruptures.sectionTitle'),
          selector: 'name',
        },
        {
          title: translate('code8.ocurr.qtt'),
          selector: 'qtt',
          centerTitle: true,
          centerData: true,
        },
        {
          title: translate('percentage'),
          selector: 'p1',
          centerTitle: true,
          centerData: true,
          parsingFn: (v) => `${v}%`,
        },
        {
          title: translate('occurrences-code8.section.printed'),
          selector: 'tr',
          centerTitle: true,
          centerData: true,
        },
        {
          title: translate('percentage'),
          selector: 'p2',
          centerTitle: true,
          centerData: true,
          parsingFn: (v) => `${v}%`,
        },
        {
          title: translate("bank_statement.total_discount"),
          selector: 'totalValue',
          centerTitle: true,
          centerData: true,

        }
      ],
      data: code8Occurrences.sections ?? [],
    }
  }

  get filtersOverlay0045Classnames() {
    const { showFilters, showReport } = this.state

    let classNames = 'filters-overlay'
    if (showFilters && showReport) classNames += ' show'
    return classNames
  }

  get filtersClassnames() {
    const { showFilters, showReport } = this.state

    let classNames = 'filters'
    if (showReport) classNames += ' fixed'
    if (showFilters) classNames += ' open'
    return classNames
  }

  get formFields() {
    const { translate } = this.props

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        required: true,
        onChangeValue: (e) => {
          this.setState(prevState => ({
            formData: {
              ...prevState.formData,
              locationId: this.formatBranchs(e.target.value)
            }
          }))
        }
      },
      {
        type: 'sections',
        name: 'section',
        help_text: translate('select.section'),
        label: translate('section'),
        required: true,
        onChangeValue: (e) => {
          this.setState(prevState => ({
            formData: {
              ...prevState.formData,
              sections: this.formatSections(e)
            }
          }))
        }
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
        onChangeValue: (e) => {
          this.setState(prevState => ({
            formData: {
              ...prevState.formData,
              ...this.formatData(e)
            }
          }))
        }
      },
    ]
  }

  formatData(dtRange) {
    const dateStart = dtRange[0].format('YYYY-MM-DD')
    const dateEnd = dtRange[1].format('YYYY-MM-DD')
    return {dateStart, dateEnd}
  }

  formatSections(sections = {}) {
   const arraySections = Object.values(sections)
   return arraySections.map(s => s.sectionId.toString())

  }

  formatBranchs(branchsObject = []) {
        const branchs = []
        for (const b of branchsObject) {
          if (b.idBranches) {
            branchs.push(...b.idBranches)
          } else {
            branchs.push(b.value)
          }
        }
        return branchs.filter((b, p) => branchs.indexOf(b) === p)
  }

  getCsv = () => {
    const {formData} = this.state
    const {
      fetchFluxReport,
      translate,
      auth: { user },
    } = this.props

    const values = {
      tpReport: EVENT_MANAGEMENT_CODE_REPORT,
    }
    const filters = {
      dtEnd: moment(formData.dateEnd).format("DD/MM/YYYY"),
      dtStart: moment(formData.dateStart).format("DD/MM/YYYY"),
      idBranch: "0999",
      idBranches: formData.locationId,
      allBranches: false,
      idSections: formData.sections

    }
    signalController = new AbortController();
    fetchFluxReport(user.dsToken, values, filters, translate, signalController )

  }

  getCsvRecurrence = () => {
    const {formData} = this.state
    const {
      fetchFluxReport,
      translate,
      auth: { user },
    } = this.props

    const values = {
      tpReport: 24,
    }

    const filters = {
      dtEnd: moment(formData.dateEnd).format("DD/MM/YYYY"),
      dtStart: moment(formData.dateStart).format("DD/MM/YYYY"),
      idBranch: "0999",
      idBranches: formData.locationId,
      allBranches: false,
      idSections: formData.sections

    }

    signalController = new AbortController();
    fetchFluxReport(user.dsToken, values, filters, translate, signalController)
  }

  reportCode8Csv = (idReport) => {

    const {formData} = this.state
    const {
      fetchFluxReport,
      translate,
      auth: { user },
    } = this.props

    const values = {
      tpReport: idReport,
    }

    const params = {
      locationId: formData.locationId,
      dateStart: formData.dateStart,
      dateEnd: formData.dateEnd,
      section: formData.sections,
      eventCode: OCCURENCE_CODE_8
    }

    signalController = new AbortController()
    fetchFluxReport(user.dsToken, values, params, translate, signalController )

  }



  handleFilterSubmit = () => {
    const { fetchCode8OccurrencesV2 } = this.props
    const {formData} = this.state
    const handleFetchCode8Occurrences = () => {
      const {auth} = this.props
      const params = {
        locationId: formData.locationId,
        dateStart: formData.dateStart,
        dateEnd: formData.dateEnd,
        section: formData.sections,
        eventCode: OCCURENCE_CODE_8
      }

      const dateStartFiltered = moment(formData.dateStart).format('DD/MM/YYYY')
      const dateEndFiltered = moment(formData.dateEnd).format('DD/MM/YYYY')

      this.setState({
        dateEndFiltered,
        dateStartFiltered
      })

      signalController = new AbortController()
      fetchCode8OccurrencesV2(auth.user.dsToken, params, signalController)

    }

    handleFetchCode8Occurrences()

    this.setState({
        showReport: true,
        showFilters: false,
    })
  }

  closeModal = () =>
    this.setState({
      detailsMode: null,
    })

  render() {
    const { showReport, detailsMode, sectionStoresTab } = this.state
    const { translate, code8Occurrences } = this.props

    return (
      <div className='common-report new-code-8'>
        <div className='title'>
          <h1>{'Relatório de ocorrências de código 8'}</h1>
        </div>

        <div className='content'>
          <div className={this.filtersOverlayClassnames} />
          <div className={this.filtersClassnames}>
            <div
              className='close'
              onClick={() =>
                this.setState({
                  showFilters: false,
                })
              }
            >
              <CloseSVG />
            </div>
            <h2>{translate('commonReport.filters')}</h2>
            <Form
              fields={this.formFields}
              onSubmit={this.handleFilterSubmit}
              translate={translate}
            />
          </div>

          {showReport && (
            <div className='top'>
              <div className='left' />
              <div className='right'>
                <button onClick={() => this.getCsv()} className='btn download'>
                  <DownloadSVG className="default-relatory-svg" />
                  <span>{translate('commonReport.download')}</span>
                </button>
                <button
                  onClick={() =>
                    this.setState({
                      showFilters: true,
                    })
                  }
                  className='btn'
                >
                  <FilterSVG className="default-relatory-svg" />
                  <span>{translate('mobile.filter')}</span>
                </button>
              </div>
            </div>
          )}

          {showReport && (
            <div className='new-code-8-cards-wrapper'>
              <Card title={translate('code8.occurrences.card.title')}>
                <br />
                <span className='big-number'>{code8Occurrences.totalOccurrencesQtt || 0}</span>{' '}
                {translate('sectionAccuracy.dsTotal')}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className='big-number'>{code8Occurrences.occurrencestreatedQtt || 0}</span>{' '}
                {translate('occurrences-code8.totalTreatedTitle')}
                <br />
                <p>{translate('occurr.code.8.card.title.1')}</p>
                <br />
                <span className='semibold'>
                {this.state.dateStartFiltered || moment().format('DD/MM/YYYY')} -{' '}
                {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
                </span>
              </Card>

              <Card title={translate('code8.sections.stores.card.title')}>
                <br />
                <span className='big-number'>{code8Occurrences.sectionsQtt ?? 0}</span>{' '}
                {translate('ruptures.sectionTitle')}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className='big-number'>{code8Occurrences.storeQtt ?? 0}</span>{' '}
                {translate('scheduleBlock.branchs')}
                <br />
                <p>{translate('occurr.code.8.card.title.1')}</p>
                <br />
                <button
                  onClick={() =>
                    this.setState({
                      detailsMode: 1,
                      sectionStoresTab: false,
                    })
                  }
                  className='btn btn-secondary full-w'
                >
                  {translate('see.details')}
                </button>
              </Card>

              <Card title={translate('code8.lms.reocurring.card.title')}>
                <br />
                <span className='big-number'>{code8Occurrences.reccurenceQtt ?? 0}</span>
                <br />
                <p>{translate('occurr.code.8.card.title.2')}</p>
                <br />
                <ReportDownloadBtn onReport={() => this.getCsvRecurrence()}  t={translate} fullW  />
              </Card>

              <Card title={translate('code8.receipt.loss.card.title')}>
                <br />
                <span className='big-number red'>R$ {code8Occurrences.revenueLoss ?? 0}</span>
                <br />
                <p>{translate('occurr.code.8.card.title.3')}</p>
                <br />
                <button
                  onClick={() =>
                    this.setState({
                      detailsMode: 2,
                      sectionStoresTab: false,
                    })
                  }
                  className='btn btn-secondary full-w'
                >
                  {translate('see.details')}
                </button>
              </Card>
            </div>
          )}
        </div>

        {detailsMode === 1 && (
          <Modal
            className='code-8-modal'
            closeModal={this.closeModal}
            size='md'
          >
            <br />
            <div className='modal-title'>
              {sectionStoresTab ? translate('STORES') : translate('SECTIONS')}
            </div>
            {sectionStoresTab ? (
              <>
                <span className='big-number'>{code8Occurrences.storeQtt ?? 0}</span>
                <br />
                {this.state.dateStartFiltered || moment().format('DD/MM/YYYY')} -{' '}
                {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
                <p>{translate('total.code8.store.count')}</p>
              </>
            ) : (
              <>
                <span className='big-number'>{code8Occurrences.sectionsQtt ?? 0}</span>
                <br />
                {this.state.dateStartFiltered || moment().format('DD/MM/YYYY')} -{' '}
                {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
                <p>{translate('total.code8.sections.count')}</p>
              </>
            )}

            <br />

            <NavTab
              onChange={(tab) => this.setState({ sectionStoresTab: !!tab })}
              defaultTab={0}
            >
              <Tab title={translate('ocurr.code.8.by.section')}>
                <CompactTable {...this.compactTableModalDataMockSections} />
              </Tab>
              <Tab title={translate('ocurr.code.8.by.store')}>
                <table className='full-w text-center header-table'>
                  <thead>
                    <tr>
                      <td className='text-left' width='30%'>{translate('scheduleBlock.branchs')}</td>
                      <td className='text-center'  width='20%'>
                        {translate('code8.ocurr.qtt')}
                      </td>
                      <td className='text-center' width='7.5%'>
                        %
                      </td>
                      <td className='text-center' width='15%'>
                        {translate('occurrences-code8.section.printed')}
                      </td>
                      <td className='text-center' width='7.5%'>
                        %
                      </td>

                      <td className='text-center' width='20%' >
                        {translate('bank_statement.total_discount')}
                      </td>
                    </tr>
                  </thead>
                </table>
                {(code8Occurrences.stores ?? []).map(ev => (
                    <Accordion
                    isNewComponent
                    key={ev.name}
                    size='sm'
                    title={
                    <AccordionTableTitleStores
                      branch={ev.name}
                      ocurrQtt={ev.qtt}
                      ocurrPercentage={`${ev.p1  }%`}
                      treatedQtt={ev.tr}
                      tretaedPercentage={`${ev.p2  }%`}
                      totalValue={ev.totalValue}
                    />
                  }
                  className='margin-top no-margin-bottom accordion-box'>

                    <CompactTable
                      {...this.compactTableAccordionStoresDataMock(ev.storeDetails)}
                    />

                  </Accordion>

                  ))}

              </Tab>
            </NavTab>
            <div className='modal-buttons-footer'>
              <button
                onClick={() => this.closeModal()}
                className='custom-modal-close-button'
              >
                {translate('close_button_label')}
              </button>
              <ReportDownloadBtn onReport={() => sectionStoresTab ? this.reportCode8Csv(OCCURENCE_STORES_CODE_REPORT) : this.reportCode8Csv(OCCURENCE_SECTIONS_CODE_REPORT)} t={translate} />
            </div>
          </Modal>
        )}

        {detailsMode === 2 && (
          <Modal
            className='code-8-modal'
            closeModal={this.closeModal}
            size='md'
          >
            <br />
            <div className='modal-title'>
              {translate('code8.receipt.loss.card.title')}
            </div>
            <span className='big-number red'>R${code8Occurrences.revenueLoss ?? 0}</span>
            <br />
            {this.state.dateStartFiltered || moment().format('DD/MM/YYYY')} -{' '}
            {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
            <br />
            <p>
              {translate(
                sectionStoresTab
                  ? 'ocurr.code.store.price.divergent'
                  : 'ocurr.code.store.section.divergent'
              )}
            </p>
            <br />
            <NavTab
              onChange={(tab) => this.setState({ sectionStoresTab: !!tab })}
              defaultTab={0}
            >
              <Tab title={translate('ocurr.code.8.by.section')}>
                <CompactTable {...this.compactTableModalDataMock} />
              </Tab>

              <Tab title={translate('ocurr.code.8.by.store')}>
                <table className='full-w text-left header-table'>
                  <thead>
                    <tr>
                      <td width='50%'>{translate('scheduleBlock.branchs')}</td>
                      <td className='text-center' width='25%'>
                        {translate('order_status.value')}
                      </td>
                      <td className='text-center' width='25%'>
                        %
                      </td>
                    </tr>
                  </thead>
                </table>

                {(code8Occurrences.revenueLossStores ?? []).map(store =>  (

                    <Accordion
                    isNewComponent
                    key={store.branch}
                    size='sm'
                    title={
                      <AccordionTableTitleLost
                        branch={store.branch}
                        value={`R$ ${store.value}`}
                        percentage={`${store.percent}%`}
                      />
                    }
                    className='margin-top no-margin-bottom accordion-box'
                  >
                    <CompactTable {...this.compactTableAccordionDataMock(store.sectionsDetails)} />
                  </Accordion>
                ))}

              </Tab>
            </NavTab>
            <div className='modal-buttons-footer'>
              <button
                onClick={this.closeModal}
                className='custom-modal-close-button'
              >
                {translate('close_button_label')}
              </button>
              <ReportDownloadBtn onReport={() => sectionStoresTab ? this.reportCode8Csv(CODE8REVENUE_STORE_CODE_REPORT) : this.reportCode8Csv(CODE8REVENUE_SECTIONS_CODE_REPORT)} t={translate} />
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

NewOccurrenceCode8.propTypes = {
  auth: propTypes.object.isRequired,
  translate: propTypes.func,
  showSpinner: propTypes.func,
  hideSpinner: propTypes.func,
  code8Occurrences: propTypes.object,
  error: propTypes.object,
  fetchCode8OccurrencesV2: propTypes.func,
  fetchReports: propTypes.func.isRequired,
  fetchFluxReport: propTypes.func.isRequired
}

const mapStateToProps = ({ code8OccurrencesReducer }) => ({
  code8Occurrences: code8OccurrencesReducer.record,
  error: code8OccurrencesReducer.error,
  filters: code8OccurrencesReducer.filters,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...spinnerActions, ...code8Actions, ...reportActions },
    dispatch
  )

export default connect( mapStateToProps , mapDispatchToProps)(NewOccurrenceCode8)
